/*@flow*/
import type { Element } from 'react';
import React from 'react';

type PropsT = {
  name: string,
  minName: string,
  maxName: string,
  minValue: any,
  maxValue: any,
  onChange: ([any, any]) => void,
};

export default ({
  name,
  onChange,
  minValue,
  maxValue,
  minName,
  maxName,
}: PropsT): Element<'div'> => (
  <div className="row">
    <div className="col-lg-6 col-md-6">
      <label className="col-form-label">Start</label>
      <input
        type="date"
        value={minValue}
        className="form-control text-control"
        name={`${name}[${minName}]`}
        onChange={(e) => {
          onChange([e.target.value, maxValue]);
        }}
      />
    </div>
    <div className="col-lg-6 col-md-6">
      <label className="col-form-label">End</label>
      <input
        type="date"
        value={maxValue}
        name={`${name}[${maxName}]`}
        className="form-control text-control"
        onChange={(e) => {
          onChange([minValue, e.target.value]);
        }}
      />
    </div>
  </div>
);
